<template>
	<v-container fluid grid-list-lg class="pa-3">
		<v-layout row wrap>
			<v-flex>
				<v-card>
					<v-toolbar dense prominent>
						<v-toolbar-title>Others Factor Listing Page</v-toolbar-title>
						<v-spacer></v-spacer>

						<v-toolbar-items>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<input type="file" ref="fileUpload" accept=".csv" v-show="false" />
									<v-btn color="primary" small fab v-on="on" href="/FPES-Admin-Upload?uuid=9e7120d6-2941-4d57-908f-666757b9303b">
										<v-icon>upload</v-icon>
									</v-btn>
								</template>
								<span>Upload page</span>
							</v-tooltip>

						</v-toolbar-items>
					</v-toolbar>
					<v-card-title>
						<v-container fluid>
							<v-layout row wrap>
								<v-flex xs12 sm6 md4 lg3>
									<v-text-field label="Username contain" v-model="custom_filter.username" prepend-icon="account_box" placeholder="Key in username here."></v-text-field>
								</v-flex>
							</v-layout>
							<v-layout row wrap>
								<v-flex xs12 sm6 md4 lg3>
									<v-menu v-model="custom_filter.less_than_menu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">

										<template v-slot:activator="{ on }">
											<v-text-field v-model="custom_filter.less_than_date" label="Date <=" prepend-icon="event" placeholder="Date less than or equal." readonly v-on="on"></v-text-field>
										</template>
										<v-date-picker v-model="custom_filter.less_than_date" @input="custom_filter.less_than_menu = false" no-title scrollable></v-date-picker>
									</v-menu>
								</v-flex>
							</v-layout>
							<v-layout row wrap>
								<v-flex xs12 sm6 md4 lg3>
									<v-menu v-model="custom_filter.greater_than_menu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">

										<template v-slot:activator="{ on }">
											<v-text-field v-model="custom_filter.greater_than_date" label="Date >=" prepend-icon="event" placeholder="Date greater than or equal." readonly v-on="on"></v-text-field>
										</template>
										<v-date-picker v-model="custom_filter.greater_than_date" @input="custom_filter.greater_than_menu = false" no-title scrollable></v-date-picker>
									</v-menu>
								</v-flex>
							</v-layout>

							<v-layout row wrap>
								<v-flex xs12 sm6 md4 lg3>
									<v-btn block color="primary" @click="reload_table">filter</v-btn>
									<v-btn block @click="reset_all">reset</v-btn>
								</v-flex>
							</v-layout>

						</v-container>
					</v-card-title>
					<v-card-text class="pa-0">
						<v-data-table :pagination.sync="table.pagination" :rows-per-page-items="table.rows_per_page_items" :total-items="table.total_items" :headers="table.headers.filter(r => r.viewable == true)" :loading="table.loading" :items="table.items">

							<template v-slot:items="props">
								<td>{{ props.item._id }}</td>
								<td>{{ epoch2localedatetime(props.item.created) }}</td>
								<td>{{ props.item.created_by }}</td>
								<td>{{ epoch2localedatetime(props.item.modified) }}</td>
								<td>{{ props.item.modified_by }}</td>
								<td>{{ props.item.username }}</td>
								<td>{{ props.item.date }}</td>
								<td>{{ props.item.eul }}</td>
								<td>{{ props.item.lateness }}</td>
								<td>{{ props.item.mc }}</td>
							</template>

						</v-data-table>

					</v-card-text>
				</v-card>

			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import general from "../../functions/general";
import query_builder from "../../functions/query.builder";

export default {
	name: "Admin-Factor-Listing",
	mounted() {
		general.App.set_page_title("mySuite : Other Factor Listing page.");
	},
	watch: {
		"table.pagination": {
			handler: function () {
				this.reload_table();
			},
			deep: true
		},
	},
	data() {
		return {
			custom_filter: {
				username: "",
				less_than_date: "",
				greater_than_date: "",
				less_than_menu: false,
				greater_than_menu: false
			},
			table: {
				headers: [
					{
						text: "ID",
						value: "_id",
						align: "left",
						sortable: true,
						viewable: true,
						type: "String",
						class: "",
						width: ""
					},
					{
						text: "Created",
						value: "created",
						align: "left",
						sortable: true,
						viewable: true,
						type: "DateTime",
						class: "font-weight-black",
						width: ""
					},
					{
						text: "Created By",
						value: "created_by",
						align: "left",
						type: "String",
						sortable: true,
						viewable: true,
						class: "font-weight-black",
						width: ""
					},
					{
						text: "Modified",
						value: "modified",
						align: "left",
						sortable: true,
						viewable: true,
						type: "DateTime",
						class: "font-weight-black",
						width: ""
					},
					{
						text: "Modified By",
						value: "modified_by",
						align: "left",
						type: "String",
						sortable: true,
						viewable: true,
						class: "font-weight-black",
						width: ""
					},
					{
						text: "Username",
						value: "username",
						align: "left",
						sortable: true,
						viewable: true,
						type: "String",
						class: "font-weight-black",
						width: ""
					},
					{
						text: "Date",
						value: "date",
						align: "left",
						sortable: true,
						viewable: true,
						type: "String",
						class: "font-weight-black",
						width: ""
					},
					{
						text: "EUL",
						value: "eul",
						align: "left",
						sortable: true,
						viewable: true,
						type: "Number",
						class: "font-weight-black",
						width: ""
					}, {
						text: "Laterness",
						value: "lateness",
						align: "left",
						sortable: true,
						viewable: true,
						type: "Number",
						class: "font-weight-black",
						width: ""
					},
					{
						text: "MC",
						value: "mc",
						align: "left",
						sortable: true,
						viewable: true,
						type: "Number",
						class: "font-weight-black",
						width: ""
					}
				],
				items: [],
				total_items: 0,
				rows_per_page_items: [25, 50, 100, 200, 1000],
				loading: false,
				pagination: {
					descending: true,
					page: 1,
					rowsPerPage: 25,
					sortBy: "_id",
					totalItems: 100
				},
			},
		};
	},
	computed: {},
	methods: {
		reset_all(){
			this.custom_filter.username = "";
			this.custom_filter.less_than_date = "";
			this.custom_filter.greater_than_date = "";

			this.reload_table();
		},
		epoch2localedatetime: general.App.epoch2LocaleDatetime,
		async reload_table() {
			var rule = null;
			this.table.loading = true;
			var qb = new query_builder.QueryBuilder();

			qb.Table = "fpes_negative_factors_view";
			qb.Limit = this.table.pagination.rowsPerPage;
			qb.Offset = this.table.pagination.page;

			if (this.custom_filter.username.length > 0) {
				rule = new query_builder.Rule();
				rule
					.field("username")
					.operator(query_builder.A_STR_OPERATOR.I_CONTAINS)
					.value(this.custom_filter.username);
				qb.addRule(rule);
			}

			if (this.custom_filter.less_than_date.length > 0) {
				rule = new query_builder.Rule();
				rule
					.field("date")
					.operator(query_builder.A_STR_OPERATOR.GREATER_THEN_EQUAL)
					.value(this.custom_filter.less_than_date);
				qb.addRule(rule);
			}

			if (this.custom_filter.greater_than_date.length > 0) {
				rule = new query_builder.Rule();
				rule
					.field("date")
					.operator(query_builder.A_STR_OPERATOR.LESS_THEN_EQUAL)
					.value(this.custom_filter.greater_than_date);
				qb.addRule(rule);
			}

			// must check sortBy before push in order array
			if (this.table.pagination.sortBy) {
				qb.Order = [
					{
						name: this.table.pagination.sortBy,
						descending: this.table.pagination.descending,
					}
				];
			}

			var res = await general.wBackEndComm.PostData("process_arango_qb/", qb);
			res = res.data;
			if (res.Status == 1) {
				this.table.items = res.Body[0].records;
				this.table.total_items = res.Body[0].total_records;
			} else {
				general.wMsgBox.Error(res.Description);
			}

			this.table.loading = false;
		},
	},
};
</script>

<style scoped></style>
